<template>
  <div id="tld-detail" v-if="detail.id > 0">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'TLD'|t }}:</td>
        <td>{{ detail.tld }}</td>
      </tr>
      <tr>
        <td>{{ 'Price'|t }}:</td>
        <td>{{ detail.price }} credits</td>
      </tr>
      <tr>
        <td>{{ 'Length'|t }}:</td>
        <td>{{ detail.min_domain_length }}-{{ detail.max_domain_length }} characters</td>
      </tr>
      <tr>
        <td>{{ 'Minimum period'|t }}:</td>
        <td>{{ detail.period }} years</td>
      </tr>
      <tr>
        <td>{{ 'Period transfer'|t }}:</td>
        <td>{{ detail.period_transfer }} days</td>
      </tr>
      <tr>
        <td>{{ 'Registrant country code'|t }}:</td>
        <td><flag :iso="detail.registrant_cc"></flag></td>
      </tr>
      <tr>
        <td>{{ 'Allow IDN'|t }}:</td>
        <td>{{ detail.idn_allowed ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Require IDNum'|t }}:</td>
        <td>{{ detail.idnum_required ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Require VAT'|t }}:</td>
        <td>{{ detail.vat_required ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Require date of birth'|t }}:</td>
        <td>{{ detail.birthday_required ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Confirmation needed'|t }}:</td>
        <td>{{ detail.confirmation ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Auto-renew period'|t }}:</td>
        <td>{{ detail.auto_renew_period }} days</td>
      </tr>
      <tr>
        <td>{{ 'RGP period'|t }}:</td>
        <td>{{ detail.rgp_period }} days</td>
      </tr>
      <tr>
        <td>{{ 'Pending delete period'|t }}:</td>
        <td>{{ detail.pending_delete_period }} days</td>
      </tr>
      <tr>
        <td>{{ 'Expiration policy'|t }}:</td>
        <td>{{ detail.expiration_policy }}</td>
      </tr>
      <tr>
        <td>{{ 'Require name servers'|t }}:</td>
        <td>{{ detail.ns_required ? 'yes' : 'no' }}</td>
      </tr>
      <tr>
        <td>{{ 'Plain transfer'|t }}:</td>
        <td>{{ detail.plain_transfer ? 'yes' : 'no' }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import api from '@/api';

  export default {
    name: 'Detail',
    props: {
      tld: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        detail: {
          id: 0
        }
      }
    },
    created() {
      api.viewTLD(
        {tld: this.tld},
        data => this.detail = data
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/tld/Detail.vue